const Bag = ({ ...props }) => {
    return (
        <svg
            width="22"
            height="24"
            viewBox="0 0 20 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.4105 5.55174C14.4105 3.25901 12.5519 1.40039 10.2591 1.40039C7.9664 1.40039 6.10777 3.25901 6.10777 5.55174M3.51318 20.6004H16.4862C17.6325 20.6004 18.5618 19.6711 18.5618 18.5247V7.62742C18.5618 6.48105 17.6325 5.55174 16.4862 5.55174H3.51318C2.36681 5.55174 1.4375 6.48105 1.4375 7.62742V18.5247C1.4375 19.6711 2.36681 20.6004 3.51318 20.6004Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default Bag
